module.exports = __webpack_public_path__ + "img/office.4bba4705.svg";